// frontend/src/admin/QARichContentPage.js
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import QARichContentEditor from './QARichContentEditor';

const QARichContentPage = () => {
    const { qaId } = useParams();
    const [searchParams] = useSearchParams();
    const id = parseInt(qaId, 10);

    // Scope carried over from the main QA page (enables "New Question — same scope")
    const scope = {
        subject_id:     searchParams.get('subject_id')     || '',
        chapter_id:     searchParams.get('chapter_id')     || '',
        topic_id:       searchParams.get('topic_id')       || '',
        subtopic_id:    searchParams.get('subtopic_id')    || '',
        chunk_id:       searchParams.get('chunk_id')       || '',
        micro_chunk_id: searchParams.get('micro_chunk_id') || '',
        question_type:  searchParams.get('question_type')  || '',
        parent_id:      searchParams.get('parent_id')      || ''
    };

    return (
        <QARichContentEditor
            qaId={id}
            scope={scope}
            onBack={() => window.close()}
        />
    );
};

export default QARichContentPage;